module.exports = __webpack_public_path__ + "img/report_pic_color_d@2x.a565303b.png";